import {get, post, put, del} from "@/utils/request";

export default {
    getListByQuestion: (param) => {
        return get('/suggestion/listByQuestion', param);
    },
    submitSuggestion:(data) =>{
        return post('/suggestion/add',data)
    },
    updateQuestionData:(data) =>{
        return put('/suggestion/updateQuestion',data)
    },
    updateData:(data) =>{
        return put('/suggestion/update',data)
    },
    getProblemFeedbackList:(param) => {
        return get('/suggestion/getProblemFeedbackList', param);
    }
}